import React from 'react';
import PropTypes from 'prop-types';

/**
 * @description - this component is needed to provide specific function to its children to do specific actions and based on setOpen function received from ModalControl => will be integrated to PG-UI
 */
const ModalControlClose = ({ action, children, setOpen, isOpen }) => {
    const finalAction = () => {
        if (action) {
            action();
        }

        setOpen(!isOpen);
    };

    return (
        children &&
        React.cloneElement(children, {
            onMouseDown: () => finalAction(),
        })
    );
};

ModalControlClose.propTypes = {
    action: PropTypes.func,
    setOpen: PropTypes.func,
};

export default ModalControlClose;
